import React from 'react';
import PropTypes from 'prop-types';
import RadioGroup from '../RadioGroup';
import { SFEntityID } from 'utils/types';
import css from './CoursesView.css';
import { getWord } from "utils/tenant";

export default class CoursesView extends React.Component {
  render() {
    return (
      <div className={css['content']}>
        <div className="course-title">{`Which ${getWord('course', true)} do you want to meet for?`}</div>
        <RadioGroup
          name="change-course-radio"
          options={this.props.courseOptions}
          value={this.props.courseContextId}
          onSelectOption={this.props.onCourseSelected}
        />
      </div>
    );
  }
}

CoursesView.propTypes = {
  courseOptions: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  })),
  courseContextId: SFEntityID,
  onCourseSelected: PropTypes.func.isRequired
}
